import { toggleBlocking } from "../store/actions";
import store from "../store/configureStore";

export const setBlocking = (status) => store.dispatch(toggleBlocking(status));
